export const ConsumerNetIncomeFormUat = {
  submitButton: 'consumerNetIncome.submitButton',
  sliderLabel: 'consumerNetIncome.sliderLabel',
  slider: 'consumerNetIncome.slider',
  moreInfo: 'consumerNetIncome.moreInfo',
}
